import { z } from "zod";
import { equipmentAvailabilityOutput, equipmentPlace } from "./equipment";
/**
 * Several gyms on the wire — `GET`/`POST /me/gyms`, `PUT`/`DELETE
 * /me/gyms/:id` and `POST /me/gyms/:id/use` (`D202`).
 *
 * A gym is a NAMED PRESET of the equipment checklist. The equipment in
 * effect is still `/me/equipment` and nothing else — every engine read and
 * the trainer's tools read only that — and "Usar esta" writes the preset into
 * it through the same use case, so the change log shows the switch.
 *
 * The id is the device's (a UUIDv7): a create resent after a lost answer is
 * the same gym, answered 200 with the stored row instead of 201 (`D163`).
 */
/** Restated in `core/model/athlete-gym.ts`; `contract-vocabulary.test.ts`
 *  holds each pair equal. */
export const MAX_GYM_NAME_LENGTH = 40;
export const MAX_GYMS = 10;
export const MAX_GYM_EQUIPMENT = 100;
const gymId = z.string().min(1).max(64);
const gymName = z.string().trim().min(1).max(MAX_GYM_NAME_LENGTH);
const gymEquipmentIds = z
    .array(z.int().positive())
    .min(1)
    .max(MAX_GYM_EQUIPMENT);
/**
 * `POST /me/gyms`. `equipmentIds` and `place` ABSENT copy what is in effect —
 * "salvar o que tenho como academia" — and `place: null` says the gym has no
 * place. Strict: an unknown key is a 422 (`D172`).
 */
export const gymCreateInput = z.strictObject({
    equipmentIds: gymEquipmentIds.optional(),
    id: gymId,
    name: gymName,
    place: equipmentPlace.nullable().optional(),
});
/** `PUT /me/gyms/:id` — the whole preset, replaced. */
export const gymUpdateInput = z.strictObject({
    equipmentIds: gymEquipmentIds,
    name: gymName,
    place: equipmentPlace.nullable(),
});
/** One gym. `z.object`, like every output: a later field must not fail the
 *  parse in an installed app. */
export const gymOutput = z.object({
    createdAt: z.iso.datetime(),
    equipmentIds: z.array(z.int()),
    id: z.string(),
    /** The last "Usar esta"; `null` when it was never switched to. */
    lastUsedAt: z.iso.datetime().nullable(),
    name: z.string(),
    place: equipmentPlace.nullable(),
    updatedAt: z.iso.datetime(),
});
export const gymListOutput = z.object({
    /** The live gym switched to most recently — the one the chip marks — or
     *  `null` when none ever was. */
    currentGymId: z.string().nullable(),
    /** Oldest first: the list does not reorder itself on a switch. */
    gyms: z.array(gymOutput),
});
/** `POST /me/gyms/:id/use` — the gym, stamped, and the equipment now in
 *  effect, read back as `GET /me/equipment` would answer it. */
export const gymSwitchOutput = z.object({
    equipment: equipmentAvailabilityOutput,
    gym: gymOutput,
});
//# sourceMappingURL=gyms.js.map